var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListview(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25,7.5H8.75C8.34,7.5,8,7.16,8,6.75S8.34,6,8.75,6h11.5C20.66,6,21,6.34,21,6.75S20.66,7.5,20.25,7.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25,12.75H8.75C8.34,12.75,8,12.41,8,12s0.34-0.75,0.75-0.75h11.5c0.41,0,0.75,0.34,0.75,0.75S20.66,12.75,20.25,12.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25,18H8.75C8.34,18,8,17.66,8,17.25s0.34-0.75,0.75-0.75h11.5c0.41,0,0.75,0.34,0.75,0.75S20.66,18,20.25,18z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25,18h-1.5C3.34,18,3,17.66,3,17.25s0.34-0.75,0.75-0.75h1.5C5.66,16.5,6,16.84,6,17.25S5.66,18,5.25,18z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25,12.75h-1.5C3.34,12.75,3,12.41,3,12s0.34-0.75,0.75-0.75h1.5C5.66,11.25,6,11.59,6,12S5.66,12.75,5.25,12.75z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25,7.5h-1.5C3.34,7.5,3,7.16,3,6.75S3.34,6,3.75,6h1.5C5.66,6,6,6.34,6,6.75S5.66,7.5,5.25,7.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListview);
export default __webpack_public_path__ + "static/media/listview.4a54fa6184992983903c72b9f1387583.svg";
export { ForwardRef as ReactComponent };